var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAsapSlot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/instant") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.0002472,1.99 C16.0002472,1.99 20.0002472,5.99 20.0002472,10.99 C20.0002472,15.99 16.0002472,19.9900773 11.0002472,19.9900773 C8.4360272,20.0006427 5.99004377,18.9125035 4.28100278,17.0008245 C2.57196179,15.0891456 1.76354779,12.5370192 2.06024722,9.99 L4.08024722,9.99 C3.77519585,12.0015055 4.36593908,14.0457446 5.69693344,15.5844664 C7.02792781,17.1231882 8.96577863,18.0021792 11.0002472,17.99 C14.9002472,17.99 18.0002472,14.89 18.0002472,10.99 C18.0002472,7.09 14.9002472,3.99 11.0002472,3.99 C10.3002472,3.99 9.63024722,4.09 9.00024722,4.28 L9.00024722,2.22 C9.64024722,2.07 10.3102472,1.99 11.0002472,1.99 Z M11.5,5.99 L11.5,11.29 L15.5,13.69 L14.7,14.89 L10,11.99 L10,5.99 L11.5,5.99 Z M5.05563492,7 C5.60791967,7 6.05563492,7.44771525 6.05563492,8 L6.05563492,9 L1.5,9 C0.94771525,9 0.5,8.55228475 0.5,8 L0.5,7 L5.05563492,7 Z M6,4 C6.55228475,4 7,4.44771525 7,5 L7,6 L1,6 C0.44771525,6 5.51346974e-14,5.55228475 5.5067062e-14,5 L5.5067062e-14,4 L6,4 Z M7,1 C7.55228475,1 8,1.44771525 8,2 L8,3 L2,3 C1.44771525,3 1,2.55228475 1,2 L1,1 L7,1 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/instant",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color/core/DG-Gray"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAsapSlot);
export default __webpack_public_path__ + "static/media/icon-asap-slot.6045bb6fc8242e12139d379029948ba4.svg";
export { ForwardRef as ReactComponent };